import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {PaymentRequestMovementConverter} from "../../../api/entity/paymentRequestMovement.converter";
import {PaymentRequestMovementModel} from "../../../api/entity/paymentRequestMovement.model";


@Injectable({providedIn: 'root'})
export class PaymentRequestMovementDataService extends AbstractDataServiceV2<PaymentRequestMovementModel,
    PaymentRequestMovementConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PaymentRequestMovementConverter) {
        super('PaymentRequestMovement', http, httpUrlGenerator, logger, config, converter);
    }
}
